{
  "manager": {
    "changelogDropdown": {
      "whatsNew": "What's New",
      "loadingUpdates": "Loading updates...",
      "unableToLoad": "Unable to load updates",
      "badgeNew": "New",
      "badgeImproved": "Improved",
      "badgeFixed": "Fixed",
      "moreItems": "+{count} more",
      "noUpdates": "No updates available"
    }
  }
}
